var map = {
	"./404/404": 467,
	"./404/404.html": 468,
	"./404/404.ts": 467,
	"./admin/department/department": 469,
	"./admin/department/department-edit": 174,
	"./admin/department/department-edit.html": 480,
	"./admin/department/department-edit.ts": 174,
	"./admin/department/department.html": 481,
	"./admin/department/department.ts": 469,
	"./admin/institution/institution": 482,
	"./admin/institution/institution-edit": 227,
	"./admin/institution/institution-edit.html": 483,
	"./admin/institution/institution-edit.ts": 227,
	"./admin/institution/institution.html": 486,
	"./admin/institution/institution.ts": 482,
	"./admin/institutions/institutions": 487,
	"./admin/institutions/institutions.html": 488,
	"./admin/institutions/institutions.ts": 487,
	"./admin/location/location": 489,
	"./admin/location/location.html": 490,
	"./admin/location/location.ts": 489,
	"./admin/person/person": 491,
	"./admin/person/person-edit": 230,
	"./admin/person/person-edit.html": 492,
	"./admin/person/person-edit.ts": 230,
	"./admin/person/person.html": 494,
	"./admin/person/person.ts": 491,
	"./admin/persons/persons": 495,
	"./admin/persons/persons.html": 496,
	"./admin/persons/persons.ts": 495,
	"./doccheck/login": 497,
	"./doccheck/login.html": 498,
	"./doccheck/login.ts": 497,
	"./doccheck/success": 499,
	"./doccheck/success.html": 500,
	"./doccheck/success.ts": 499,
	"./editor/_common": 57,
	"./editor/_common.ts": 57,
	"./editor/widget-cite/widget-cite": 234,
	"./editor/widget-cite/widget-cite-edit.html": 505,
	"./editor/widget-cite/widget-cite.html": 504,
	"./editor/widget-cite/widget-cite.ts": 234,
	"./editor/widget-container/layout-2-columns.html": 506,
	"./editor/widget-container/layout-3-columns.html": 507,
	"./editor/widget-container/layout-hero.html": 508,
	"./editor/widget-container/layout-left-column.html": 509,
	"./editor/widget-container/layout-vertical.html": 510,
	"./editor/widget-container/placeholder.html": 511,
	"./editor/widget-container/widget-container": 235,
	"./editor/widget-container/widget-container-edit.html": 518,
	"./editor/widget-container/widget-container.html": 517,
	"./editor/widget-container/widget-container.ts": 235,
	"./editor/widget-container/widget-selection-modalbody.html": 516,
	"./editor/widget-countdown/widget-countdown": 237,
	"./editor/widget-countdown/widget-countdown-edit.html": 520,
	"./editor/widget-countdown/widget-countdown.html": 519,
	"./editor/widget-countdown/widget-countdown.ts": 237,
	"./editor/widget-empty/widget-empty": 238,
	"./editor/widget-empty/widget-empty.html": 521,
	"./editor/widget-empty/widget-empty.ts": 238,
	"./editor/widget-gallery/widget-gallery": 239,
	"./editor/widget-gallery/widget-gallery-edit.html": 523,
	"./editor/widget-gallery/widget-gallery.html": 522,
	"./editor/widget-gallery/widget-gallery.ts": 239,
	"./editor/widget-image/widget-image": 240,
	"./editor/widget-image/widget-image-edit.html": 525,
	"./editor/widget-image/widget-image.html": 524,
	"./editor/widget-image/widget-image.ts": 240,
	"./editor/widget-page/widget-page": 241,
	"./editor/widget-page/widget-page-edit.html": 527,
	"./editor/widget-page/widget-page.html": 526,
	"./editor/widget-page/widget-page.ts": 241,
	"./editor/widget-richtext/widget-richtext": 242,
	"./editor/widget-richtext/widget-richtext-edit.html": 530,
	"./editor/widget-richtext/widget-richtext.html": 529,
	"./editor/widget-richtext/widget-richtext.ts": 242,
	"./editor/widget-utils": 134,
	"./editor/widget-utils.ts": 134,
	"./editor/widget-video/widget-video": 248,
	"./editor/widget-video/widget-video-edit.html": 532,
	"./editor/widget-video/widget-video.html": 531,
	"./editor/widget-video/widget-video.ts": 248,
	"./faqs/faqs": 533,
	"./faqs/faqs-docview": 250,
	"./faqs/faqs-docview.html": 535,
	"./faqs/faqs-docview.ts": 250,
	"./faqs/faqs-public": 249,
	"./faqs/faqs-public.html": 534,
	"./faqs/faqs-public.ts": 249,
	"./faqs/faqs.html": 536,
	"./faqs/faqs.ts": 533,
	"./home/demo_data": 537,
	"./home/demo_data.ts": 537,
	"./home/home": 538,
	"./home/home-docview": 252,
	"./home/home-docview.html": 540,
	"./home/home-docview.ts": 252,
	"./home/home-public": 251,
	"./home/home-public.html": 539,
	"./home/home-public.ts": 251,
	"./home/home.html": 541,
	"./home/home.ts": 538,
	"./info/info": 542,
	"./info/info.html": 543,
	"./info/info.ts": 542,
	"./links/links": 544,
	"./links/links.html": 545,
	"./links/links.ts": 544,
	"./service/service": 546,
	"./service/service-docview": 253,
	"./service/service-docview.html": 547,
	"./service/service-docview.ts": 253,
	"./service/service-public": 254,
	"./service/service-public.html": 548,
	"./service/service-public.ts": 254,
	"./service/service.html": 549,
	"./service/service.ts": 546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;